module.exports = __webpack_public_path__ + "static/media/trashboy_la987.5659af41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/trashboy_la987.jpg
// module id = 430
// module chunks = 0